import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './actions';
import * as LoginSelectors from 'shared_redux/selectors/view/login';
import View from './view';

const mapStateToProps = (state, ownProps) => {
    document.title = "RepOne";

    // Initialize with stored values
    let email = LoginSelectors.getEmail(state);
    let athleteInvite = null;
    let staffInvite = null;

    // Check URL parameters for email and invite code
    if (ownProps.location && ownProps.location.search) {
        const searchParams = new URLSearchParams(ownProps.location.search);
        const emailParam = searchParams.get('email');
        const inviteParam = searchParams.get('athlete_invite');
        const staffInviteParam = searchParams.get('staff_invite') || searchParams.get('staffInvite');

        // Only update email from URL if the redux store email is empty
        // This ensures we don't override user edits
        if (emailParam && (!email || email === "")) {
            email = emailParam;
        }

        // Store the athlete invite code if present
        if (inviteParam) {
            athleteInvite = inviteParam;
        }

        // Store the staff invite code if present
        if (staffInviteParam) {
            staffInvite = staffInviteParam;
        }
    }

    return {
        email,
        password: LoginSelectors.getPassword(state),
        urlParams: ownProps.location ? ownProps.location.search : '',
        athleteInvite,
        staffInvite,
        twoFaChallengeId: LoginSelectors.getTwoFaChallengeId(state),
        twoFaEmail: LoginSelectors.getTwoFaEmail(state),
        twoFaError: LoginSelectors.getTwoFaError(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        signIn: Actions.signIn,
        updateEmail: Actions.updateEmail,
        updatePassword: Actions.updatePassword,
        verifyTwoFa: Actions.verifyTwoFa,
        cancelTwoFa: Actions.cancelTwoFa,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default withRouter(Container);
